import React from "react";
import PopupWin from "../../../../../components/PopupWin";


import linkIcon from "../../../../../assets/integrations/link-icon.svg";
import image131 from "../../../../../assets/integrations/image-131.png";
import image133 from "../../../../../assets/integrations/image-133.png";

const ConnectedModal = ({ visible, onClose, onConfirm }) => {
  return (
    <PopupWin
      visible={visible}
      onClose={onClose}
      hideClose={true}
      popupStyle={{
        width: "427px",
        minHeight: "287px",
        padding: 0,
        background: "#ffffff",
        borderRadius: "10px",
        boxShadow: "0px 9px 25px 0px rgba(129, 155, 163, 0.27)",
      }}
      contentStyle={{
        padding: "50px 90px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
      className="connected-modal"
    >
      <div className="connected-modal-content">
        <h2 className="connected-modal-title">
          HubSpot Connected
        </h2>
        <div className="connected-modal-flow">
          <img
            src={image131}
            alt="Step 1"
            className="connected-modal-flow-image-left"
          />
          <img
            src={linkIcon}
            alt="Connected"
            className="connected-modal-link-icon"
          />
          <img
            src={image133}
            alt="Step 2"
            className="connected-modal-flow-image-right"
          />
        </div>
        <div className="connected-modal-button-container">
          <button
            className="connected-modal-button"
            onClick={onConfirm}
          >
            OK
          </button>
        </div>
      </div>
    </PopupWin>
  );
};

export default ConnectedModal;
